import API from 'services/api';

import { ICalculationStatement } from '../models';

interface IProps {
  statementId: string;
  companyBankAccountId: string;
}

export const createVirman = ({
  statementId,
  companyBankAccountId,
}: IProps): Promise<ICalculationStatement> => {
  return API.post(
    `api/accommodation/calculations/statements/${statementId}/virman?companyBankAccountId=${companyBankAccountId}`,
  ).then(response => response?.data);
};
